<script>
  import { onMount } from "svelte";
  import Conexoes from "../Classes/Conexoes";
  import { Accordion, Title } from "@svelteuidev/core";
  import Loading from "../componentes_basicos/Loading.svelte";
  import CaixaDeDialogo from "../componentes_basicos/CaixaDeDialogo.svelte";
  import Constantes from "../Classes/Constantes";

  let valores = [];
  let conexoes = new Conexoes(Constantes.url_base_nutri);
  let timers = {};
  let carregando = false;
  let message = "";
  let habilitado = [];
  let idApagar = 0;
  let vermelho = false;
  let ordena = 0;

  const categorias = [
    "Restaurante",
    "Feira",
    "Padaria",
    "Combustivel",
    "Uber",
    "Carro",
    "Medicamentos",
    "Estacionamentos",
    "Casa",
    "Ração",
    "Suplementos",
    "Lanche_lele_escola",
    "Lanche_lele_campestre",
    "Lanche_lele_outros",
    "Gas",
    "Piscina",
    "Outros"
  ];

  const categoriaCores = {
    Restaurante: "#ffe0cc",
    Feira: "#fff2cc",
    Padaria: "#e6f2ff",
    Combustivel: "#e6ffe6",
    Uber: "#f2e6ff",
    Carro: "#d9f2f2",
    Medicamentos: "#ffe6f0",
    Estacionamentos: "#ffe6f0",
    Casa: "#ffe6f0",
    Suplementos: "#ffe6f0",
    Lanche_lele_escola: "#ffe6f0",
    Lanche_lele_campestre: "#ffe6f0",
    Lanche_lele_outros: "#ffe6f0",
    Gas: "#ffe6f0",
    Piscina: "#ffe6f0",
    Outros: "#f9f9f9"
  };

  async function loadValores() {
    vermelho = false;
    let res = await conexoes.conecta("list_valores.php", { ordena: ordena });
    valores = res.data.map(v => ({ ...v, selected: false }));
  }

  let novoValor = { valor: "", categoria: categorias[0], pago: 0, obs: "" };

  async function addValor() {
    const raw = String(novoValor.valor ?? "").trim().replace(",", ".");
    if (raw === "") {
      message = "Informe um valor.";
      return;
    }
    const valorNum = parseFloat(raw);
    if (Number.isNaN(valorNum)) {
      message = "Valor inválido. Use apenas números.";
      return;
    }

    const payload = {
      valor: valorNum,
      categoria: novoValor.categoria || categorias[0],
      pago: Number(novoValor.pago) || 0,
      obs: novoValor.obs || ""
    };
    
    await conexoes.conecta("add_valor.php", payload);
    novoValor = { valor: "", categoria: categorias[0], pago: 0, obs: "" };
    await loadValores();
  }

  async function togglePago(id) {
    await conexoes.conecta("toggle_valor.php", { id });
    await loadValores();
  }

  // NOVA FUNÇÃO: Paga múltiplos itens
  async function pagarSelecionados() {
    // Filtra apenas os que estão selecionados E que ainda estão "A Pagar" (completed != 1)
    const itensParaPagar = valores.filter(v => v.selected && v.completed != 1);

    if (itensParaPagar.length === 0) {
      message = "Selecione pelo menos um item pendente para pagar.";
      return;
    }

    carregando = true;

    // Cria uma lista de promessas para executar todas as requisições
    const promises = itensParaPagar.map(v => 
      conexoes.conecta("toggle_valor.php", { id: v.id })
    );

    // Aguarda todas as requisições terminarem
    await Promise.all(promises);

    carregando = false;
    message = `${itensParaPagar.length} itens marcados como pagos com sucesso!`;
    await loadValores();
  }

  async function deleteValor(id) {
    idApagar = id;
    message = Constantes.msg_confirma_apagar_dados;
  }

  async function ConfirmaApagar() {
    await conexoes.conecta("delete_valor.php", { id: idApagar });
    message = "";
    await loadValores();
  }

  function scheduleUpdate(item) {
    if (timers[item.id]) clearTimeout(timers[item.id]);
    carregando = true;
    timers[item.id] = setTimeout(async () => {
      const raw = String(item.valor ?? "").trim().replace(",", "."); 
      const valorNum = parseFloat(item.title); 
      
      await conexoes.conecta("update_valor.php", {
        id: item.id,
        valor: Number.isNaN(valorNum) ? null : valorNum,
        categoria: item.categoria
      });
      carregando = false;
    }, 500);
  }

  function Ordenar() {
    ordena = (ordena === 0) ? 1 : 0;
    loadValores();
  }

  onMount(() => loadValores());

  function Habilita(i) {
    habilitado[i] = true;
    vermelho = true;
  }
</script>

<style>
  .container {
    max-width: 500px;
    margin: 20px auto;
    background: #f9f9f9;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
    border-bottom: 1px solid #ddd;
    border-radius: 6px;
  }
  .circle {
    width: 20px;
    height: 20px;
    border: 2px solid #666;
    border-radius: 50%;
    margin-right: 10px;
    cursor: pointer;
  }
  .circle.completed {
    background: #4caf50;
  }
  .valor-input {
    flex: 1;
    border: none;
    background: transparent;
    font-size: 16px;
    outline: none;
  }
  .completed-text {
    text-decoration: line-through;
    color: #888;
  }
  .actions {
    display: flex;
    gap: 8px;
    align-items: center;
  }
  .actions button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 12px;
    padding: 2px;
  }
  .actions button.delete {
    color: red;
  }
  .check-selection {
    transform: scale(1.3);
    cursor: pointer;
    margin-right: 5px;
  }
  .add {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
    gap: 10px;
  }
  .add input,
  .add select {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  .add button {
    padding: 8px 12px;
    background: #4caf50;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    border: none;
    align-self: flex-start;
  }
  /* Estilo para o botão de pagar selecionados */
  .btn-pagar-sel {
    margin-left: 10px;
    padding: 5px 10px;
    background-color: #3659fc;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
  }
  .btn-pagar-sel:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
</style>

<div class="container">
  <h2>Controle de Gastos</h2>
  <div class="add">
    <input type="number" placeholder="Valor (R$)" bind:value={novoValor.valor} />
    <select bind:value={novoValor.categoria}>
      {#each categorias as cat}
        <option value={cat}>{cat}</option>
      {/each}
    </select>
    <input type="texto" placeholder="obs" bind:value={novoValor.obs} />
    <button on:click={addValor}>Adicionar</button> <button on:click={Ordenar}>Ordena</button>
  </div>

  <Accordion multiple defaultValue={'A pagar'} chevronPosition="left" variant="separated">
    <Accordion.Item value={'A pagar'}>
      <div slot="control">
        <Title order={4} color="#3659fc">A pagar</Title>
      </div>

      {#each valores as v, i}
        {#if v.completed != 1}
          <div class="item" style="background:{categoriaCores[v.categoria] || '#fff'};">
            <div style="display:flex; align-items:center;">
              <div class="circle {v.pago == 1 ? 'completed' : ''}" on:click={() => togglePago(v.id)} />
              {#if !habilitado[i]}
                <div on:click={() => Habilita(i)} class="valor-input {v.pago == 1 ? 'completed-text' : ''}">
                  R$ {v.title} - {v.categoria} - {v.obs}
                </div>
              {:else}
                <input
                  class="valor-input"
                  type="number"
                  bind:value={v.title}
                  on:input={() => scheduleUpdate(v)} />
                <select bind:value={v.categoria} on:change={() => scheduleUpdate(v)}>
                  {#each Object.keys(categoriaCores) as cat}
                    <option>{cat}</option>
                  {/each}
                </select>
              {/if}
            </div>
            <div class="actions">
              <input type="checkbox" class="check-selection" bind:checked={v.selected} />
              <button class="delete" on:click={() => deleteValor(v.id)}>🗑️</button>
              <Loading {carregando} />
            </div>
          </div>
        {/if}
      {/each}
    </Accordion.Item>

    <Accordion.Item value={'Pago'}>
      <div slot="control">
        <Title order={4} color="#3659fc">Pago</Title>
      </div>

      {#each valores as v, i}
        {#if v.completed == 1}
          <div class="item" style="background:{categoriaCores[v.categoria] || '#fff'};">
            <div style="display:flex; align-items:center;">
              <div class="circle {v.title == 1 ? 'completed' : ''}" on:click={() => togglePago(v.id)} />
              <div class="valor-input {v.pago == 1 ? 'completed-text' : ''}">
                R$ {v.title} - {v.categoria} - {v.obs}
              </div>
            </div>
            <div class="actions">
              <input type="checkbox" class="check-selection" bind:checked={v.selected} />
              <button class="delete" on:click={() => deleteValor(v.id)}>🗑️</button>
              <Loading {carregando} />
            </div>
          </div>
        {/if}
      {/each}
    </Accordion.Item>
  </Accordion>

  <div style="margin-top:20px; padding:10px; background:#fff; border-radius:8px; border:1px solid #ddd;">
    <h3>Subtotal por categoria (a pagar)</h3>
    {#each categorias as cat}
      {#if valores.filter(v => v.completed != 1 && v.categoria === cat).length > 0}
        <div>
          {cat}: R$
          {valores
            .filter(v => v.completed != 1 && v.categoria === cat)
            .reduce((acc, v) => acc + parseFloat(v.title || 0), 0)
            .toFixed(2)}
        </div>
      {/if}
    {/each}
    <hr>
    
    <div style="color: #3659fc; margin-bottom: 5px; display:flex; align-items:center;">
      <strong>
        Selecionados: R$ 
        {valores
          .filter(v => v.selected)
          .reduce((acc, v) => acc + parseFloat(v.title || 0), 0)
          .toFixed(2)}
      </strong>
      
      {#if valores.filter(v => v.selected && v.completed != 1).length > 0}
        <button class="btn-pagar-sel" on:click={pagarSelecionados} disabled={carregando}>
           Pagar Selecionados
        </button>
      {/if}
    </div>

    <strong>
      Total geral a pagar: R$
      {valores
        .filter(v => v.completed != 1)
        .reduce((acc, v) => acc + parseFloat(v.title || 0), 0)
        .toFixed(2)}
    </strong>
  </div>
</div>

<CaixaDeDialogo
  {message}
  on:close={() => { message = ''; }}
  button1Label={'Cancelar'}
  button2Label={'Apagar'}
  button2Action={() => ConfirmaApagar()} />